import React, { useContext } from "react";
import { MobileContext } from "components/common/wrappers/withMobile";

const MarketingToolTip = ({ children }) => {
  const { isMobile } = useContext(MobileContext);
  return (
    <>
      <div
        className={
          isMobile
            ? "rounded-lg justify-center bg-transparent ml-auto my-auto mx-auto px-2"
            : "rounded-lg justify-center bg-transparent ml-auto my-auto "
        }
      >
        <div className="animate__animated animate__fadeInUp animate__delay-1s">
          {children}
        </div>
      </div>
    </>
  );
};

export default MarketingToolTip;
